import { filterOptions } from '@/utils/query-base'

const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'customerCode': {
    title: '经销商编号',
    type: 'input',
    equation: cusname,
    width: 150
  },
  'customerName': {
    title: '经销商名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'distributorCode': {
    title: '分销商编号',
    type: 'input',
    equation: cusname,
    width: 150
  },
  'distributorName': {
    title: '分销商名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'channelsTextView': {
    title: '渠道类型',
    width: 150
  },
  'startup': {
    title: '状态',
    width: 100,
    formatter: ({ cellValue }) => {
      // 将数字状态转换为文本显示
      const statusMap = {
        1: '启用',
        0: '停用',
        '-1': '删除'
      }
      return statusMap[cellValue] || cellValue
    }
  }
}




// WEBPACK FOOTER //
// ./src/views/apply-for-manage/data-searching/config/dealerShuntClientsSearch.js